<script>
  import { Bar } from 'vue-chartjs'
  export default {
    extends: Bar,
    props: ['data', 'options'],
    mounted () {
      this.renderBarChart()
    },
    computed : {
      chartData: function() {
        return this.data
      }
    },
    methods: {
      renderBarChart: function() {
        this.renderChart( {
          labels: ['Total Account',
            'Total Active',
            'Total Register',
            'Total Non Active',
            'Total Unregister',
            'Total Account Down'
          ],
          datasets: [
            {
              backgroundColor: ['#ff0000', '#0000ff', '#008000', '#ffff00', '#8d1673'],
              data: this.chartData
            }
          ]
        },
          {responsive: false, maintainAspectRatio: true, legend: { display: false}})
      }
    },
    watch: {
     data: function () {
       this.renderBarChart()
     }
    },
    beforeDestroy: function () {
      if( this._chart) {
        this._chart.destroy();
      }
    }
  }
</script>
